let baseUrl;
let cloudUrl;

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'rc') {
    // baseUrl = 'http://192.168.1.7:8080'
    // baseUrl = 'http://jike.yxboot.com/api';
    baseUrl = 'https://xapi.shuimujiaju.com'
    cloudUrl = 'https://cloud.shuimujiaju.com'
    // baseUrl = 'http://xapi.shuimushequ.com';
} else if (process.env.NODE_ENV === 'rc') {
    baseUrl = 'http://jike.yxboot.com/api';
    cloudUrl = 'https://cloud.shuimujiaju.com'
    //baseUrl = 'https://xapi.shuimujiaju.com'
} else {
    // baseUrl = 'https://xapi.shuimushequ.com';
    baseUrl = 'https://xapi.shuimujiaju.com'
    cloudUrl = 'https://cloud.shuimujiaju.com'
}

let projectKey = "com.shuimuyixing-";
let imgUrl = "https://img.shuimujiaju.com/";
let shareIcon = "https://img.shuimujiaju.com/44945fea72f44892b66e4c8059e1f0bd.jpg";
let appId = "wxd4718483b05d6d53";
let payKey = "JikejiazhuangJikejiazhuang123321";
let authUrl =
  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4718483b05d6d53&redirect_uri=https%3a%2f%2fxyz.shuimujiaju.com%2fcallback%2findex.html&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";

export { baseUrl, cloudUrl, projectKey, imgUrl, appId, payKey, authUrl, shareIcon };
